<template>
	<div class="note-app">
		<div class="note-user">
			<div class="user-title">
				<span>我的笔记</span>
			</div>
			<div class="note-list" v-if="noteList && noteList !==''">
				<div
					class="list-box"
					v-for="(item,index) in noteList"
					:key="index"
					:class="{'list-box-active' : listBoxActive == index}"
				>
					<div class="list-tab-a-box">
						<div class="list-tab-a" @click="item.name == '随机练习'?openNoteAnswer(item.sub_id,2,item.data[0].num):slideOpen(index)">
							<i></i>
							<p>{{item.name}}</p>
							<div style="margin-left: 20px;font-size: 12px;">题数：<span style="font-weight: bold;color: #e60012">{{item.num &&  item.num>0  ? item.num : 0 }}</span></div>
						</div>
					</div>
					<el-collapse-transition>
						<div class="contant" v-show="listBoxActive == index ">

							<div class="list-tab-b-box" v-for="v in item.data" :key="v.sub_id" @click="openNoteAnswer(v.sub_id,v.type||2,v.num)">
							
								<div class="list-tab-b" v-show="v.sub_id !==null" >
									<p>{{v.sub_name}}</p>
									<div  style="margin-left: 20px;font-size: 12px;">题数：<span style="font-weight: bold;color: #e60012">{{v.num}}</span></div>
								</div>
							</div>
						</div>
					</el-collapse-transition>
				</div>
			</div>
			<div v-else style="padding:20px 0; text-align:center">暂无数据</div>
		</div>
	</div>
</template>

<script>

	export default {
		name: "note-app",
		data() {
			return {
				listBoxActive: "-1",
				noteList:[],
			};
		},
		methods: {
			slideOpen(index) {
				if (this.listBoxActive == index) {
					this.listBoxActive = "-1";
				} else {
					this.listBoxActive = index;
				}
			},
			async getNoteData(){
				
						//console.log(this)
			
				//console.log("___________")
						let userInfo = JSON.parse(localStorage.getItem('userInfo'))
				     const {data:res} = await this.$api.getUserNote({user_id:userInfo.id})
						//console.log(res)
						 this.noteList =res
						 //console.log(this.noteList)
						for(let i of this.noteList){
							let n = null ;
							for(let s of  i.data){
									 n += s.num
									 i.num = n
							}
						

						}
						//console.log(this.noteList)


			// 	this.$loading();
			// 	var param = {
			// 		uid: uid,
			// 	};
			// 	this.$post("userNote", param).then((res) => {
			// 		this.noteList = res.data;
			// 	});
			// 	setTimeout(() => {
			// 		this.$loading().close();
			// 	}, 500);
			},
			openNoteAnswer(id,type,number) {
				if(number == 0){
					
					return
				}

				this.$router.push({
					path: "/answerNote",
					query: {
						sub_id: id,
						type:type,
						answer_number:number
					},
				});
				}
				
				
			},
	

		created() {
		this.getNoteData();
		},
	};
</script>

<style scoped>
	.note-user {
		padding: 0 40px 30px 40px;
	}
	.note-user .list-tab-a div,
	.note-user .list-tab-b div {
		margin-right: 0;
	}
	.note-list {
		border: 1px solid #ebebeb;
		margin-top: 30px;
		padding: 0 15px;
		padding-bottom: 15px;
		border-radius: 10px;
	}
	.note-list .list-box:last-child {
		border-bottom: none;
	}
	/* .note-app .list-box .list-tab-b-box:last-child {
		display: none;
	} */
	.list-tab-a,
	.list-tab-b {
		display: flex;
		justify-content: flex-start;
		align-items: center;
		height: 50px;
		border-bottom: 1px solid #ebebeb
	}
	
	.list-box-active .contant {
		display: block;
		padding-left: 15px;
	}
	
	.list-tab-sj i {
		background: none;
		border: 1px solid #ccc;
		border-radius: 100%;
	}
</style>
